import { IFWPauseAdSlotDimensions } from 'tag/ts/tag/interfaces/ads/pause/IFWPauseAdSlotDimensions';
import { IFWPauseAdSlotParams } from 'tag/ts/tag/interfaces/ads/pause/IFWPauseAdSlotParams';
import { FreewheelPauseAdConstants } from 'tag/ts/tag/model/FreewheelPauseAdConstants';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';

/**
 * @copyright © Paramount Streaming
 * @description Freewheel slot parameters model
 */
export class FWPauseAdSlotParams {

	readonly #params: IFWPauseAdSlotParams;

	constructor( embedType: EmbedType ) {
		const pauseAdConstants = FreewheelPauseAdConstants.getInstance();
		let slotDimensions: IFWPauseAdSlotDimensions;

		switch ( embedType ) {
			case EmbedType.DESKTOP:
				slotDimensions = pauseAdConstants.desktopSlotDimensions;
				break;

			case EmbedType.HTML5:
				slotDimensions = pauseAdConstants.stvSlotDimensions;
				break;
		}

		this.#params = {
			...pauseAdConstants.commonSlotParams,
			...slotDimensions
		};
	}

	/**
	 * @description Returns slot parameters
	 * @returns {IFWPauseAdSlotParams}
	 */
	get params(): IFWPauseAdSlotParams {
		return this.#params;
	}
}